import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySheetPrzewodnik from "@/pages/article/KakobuySheetPrzewodnik";
import NajlepszeProduktyKakobuy from "@/pages/article/NajlepszeProduktyKakobuy";
import PorownanieSpreadsheet from "@/pages/article/PorownanieSpreadsheet";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-sheet-kompletny-przewodnik",
    element: <KakobuySheetPrzewodnik />,
  },
  {
    path: "/artykul/najlepsze-produkty-kakobuy",
    element: <NajlepszeProduktyKakobuy />,
  },
  {
    path: "/artykul/porownanie-spreadsheet-kakobuy-cssbuy",
    element: <PorownanieSpreadsheet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;